module.exports = __webpack_public_path__ + "img/vdo_0.2fe87075.jpg";